// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__20oYO","title":"AfterBackImages_title__2fqfI","images":"AfterBackImages_images__28XEB"};